export default __webpack_public_path__ + "static/icon-a4b798a08cfd43a2336b490cc6e5d601.png";